import React from 'react';
import { MainProvider } from './context/MainContext';
import MainCode from './MainCode';

function App() {
  return (
    <MainProvider>
      <MainCode />
    </MainProvider>
  );
}

export default App;
